import { useEffect } from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { WELL_KNOWN_TENANT } from '@copilot/data/config/routes';
import isNil from 'lodash/isNil';
import { IOrganizationMember } from '@copilot/common/store/models/redux';

/**
 * Component that identifies the current user with LaunchDarkly
 * This enables user-specific feature flag targeting in the CS dashboard
 */
function LaunchDarklyIdentifier({ activeMember }: { activeMember?: IOrganizationMember }) {
    const ldClient = useLDClient();

    useEffect(() => {
        if (!isNil(ldClient) && !isNil(activeMember)) {
            ldClient.identify({
                key: activeMember.userId,
                name: activeMember.name,
                email: activeMember.email,
                custom: {
                    organization_id: activeMember.organizationId,
                    organization_member_roles: activeMember.orgRoles,
                    well_known_tenant: WELL_KNOWN_TENANT,
                },
            });
        }
    }, [ldClient, activeMember]);

    return null;
}

export default LaunchDarklyIdentifier;
